export const SALARYDATA_TEXTFIELD_MIN_LENGTH = 5;
export const SALARYDATA_TEXTFIELD_MAX_LENGTH = 7;

export const SALARYDATA_TEXTFIELD_PART_TIME_MIN_LENGTH = 3;
export const SALARYDATA_TEXTFIELD_PART_TIME_MAX_LENGTH = 5;

export const BONUS_TEXTFIELD_PART_PAYMENT_COUNT_MIN_LENGTH = 1;
export const BONUS_TEXTFIELD_PART_PAYMENT_COUNT_MAX_LENGTH = 3;
